<template lang="pug">
div(v-if="showDealerLocatorLink")
    template(v-if="mode === 'link'")
        div(class="flex items-center gap-x-4 pt-3 leading-tight")
            img(
                src="@/assets/dealerLocator/pin-icon.svg"
                width="27"
                height="32"
                alt="Find A Dealer"
            )
            nuxt-link(
                :to="dealerRoute"
                class="font-bold"
            )
                span(@click="emitDealerLinkEvent") Find A Local Dealer

    template(v-else)
        BaseButton(
            :to="dealerRoute"
            @click.native="emitDealerLinkEvent"
            size="MEDIUM"
            class="w-full"
        ) Find A Local Dealer

</template>

<script>
import BaseButton from '@/components/baseButton'

export default {
    name: 'DealerLocatorLink',
    components: {
        BaseButton,
    },
    props: {
        mode: {
            type: String,
            default: 'button',
        },
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        dealerRoute() {
            const routeObj = {
                name: 'dealer-locator',
            }

            if (this.$sitewideData.config.dealerLocatorShowBrandFacet && this.data.brand) {
                routeObj.query = {
                    brand: this.data.brand.name,
                }
            }

            return routeObj
        },
        showDealerLocatorLink() {
            // Should we show the link?
            const isFeatureEnabled =
                this.$sitewideData.config.dealerLocatorEnabled &&
                this.$sitewideData.config.dealerLocatorShowProductPageLink

            // If the madeByRT stuff is enabled then include that in the decision to show the link.
            if (this.$sitewideData.config.madeByRealTruckEnabled)
                return (
                    isFeatureEnabled &&
                    this.$sitewideData.config.madeByRealTruckBrands?.data.includes(
                        this.data.brand?.name
                    )
                )

            return isFeatureEnabled
        },
    },
    methods: {
        emitDealerLinkEvent(event) {
            this.$uiEvents.$emit('dealerLocatorProductLinkClicked', {
                product: this.data,
                linkText: event.target?.innerText,
                clickUrl: event.target?.pathname,
            })
        },
    },
}
</script>
